import React, { Component } from 'react';

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import { addUserRoles } from '../../actions/ipBlock';
import { getAllUserRoles } from '../../actions/ipBlock';
import { getPlan } from '../../actions/plan';
import { changeTab } from '../../actions/tab';

import PDABaseClass from '../abstract';

import { MESSAGES, TABS } from '../../utils/strings';
import { __ } from "../form/utils";
import Select from 'react-select';
import './useraccess-form.scss';

import FixRequiredSelect from '../abstract/required-select.js';

const RequiredSelect = props => (
  <FixRequiredSelect
    {...props}
    SelectComponent={Select}
    options={props.options || options}
  />
);

class UserAccessForm extends PDABaseClass {

  constructor (props) {
    super(props);
    this.setValueForMemberships = this.setValueForMemberships.bind(this);

    this.state = {
      value: [],
      loading: false,
      selectedOption: [],
	  disableSubmit: false
    };
  }

  render () {
    const { value, selectedOption, disableSubmit } = this.state;
    const { handleSubmit, plan, membersSelect, MemForm } = this.props;
    const MembershipForm = !MemForm ? (
      <div className="pda-require-update-membership">Please update the PDA
        Membership Integration to its latest
        version for our plugins to work properly.</div>
    ) : <MemForm plan={plan}
                 membersSelect={membersSelect}
                 ref={ref => this._membershipComp = ref}/>;
    const isPlanLite = plan.planName === 'lite';
    let roles = [];
    let disable = true;
    if (typeof (ip_block_server_data) !== 'undefined') {
      roles = ip_block_server_data.roles.map((role) => {
        return {
          label: role,
          value: role,
        };
      });
      if (ip_block_server_data.ip_block_activated == -1) {
        disable = false;
      }
    }

    const options = [
      {
        value: 'default',
        label: __('Use default setting'),
      },
      {
        value: 'admin-user',
        label: __('Admin users'),
        isDisabled: isPlanLite,
      },
      {
        value: 'author',
        label: __('The file\'s author'),
        isDisabled: isPlanLite,
      },
      {
        value: 'logger-in-user',
        label: __('Logged-in users'),
        isDisabled: isPlanLite,
      },
      {
        value: 'anyone',
        label: __('Anyone'),
        isDisabled: isPlanLite,
      },
      {
        value: 'blank',
        label: __('No user roles'),
        isDisabled: isPlanLite,
      },
      {
        value: 'custom-roles',
        label: __('Choose custom roles'),
        isDisabled: disable,
      },
    ];

    const form = (
      <div className="pda_form">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <div className="wrap_select">
            <div className="ip-block">
              <label>{__('Grant access to the protected link for these user roles:')}</label>
            </div>
            <div className='pda-wrap-fap'>
              <Select
                className="file_access_permision"
                removeSelected={false}
                name="file_access_permision"
                value={selectedOption}
                onChange={this.handleChange}
                placeholder="Select..."
                options={options}
              />
              {selectedOption.value == 'custom-roles' &&
              <RequiredSelect
                className="pda-role-permission"
                name="user_roles"
                isMulti
                onChange={this.handleSelectChange}
                options={roles}
                placeholder="Select user access"
                value={value}
                required
              />
              }
            </div>
            {!isPlanLite && ip_block_server_data.ip_block_activated != -1 &&
            <p>{__('Please activate')} <a target="_blank"
                                 href="https://preventdirectaccess.com/extensions/wordpress-restrict-page-file-access/">
	            {__('Access Restriction extension')}</a>
	            {__('to give file access permission to specific users or user roles')}.</p>
            }
            {(pda_gold_v3_data.pda_membership_integration_activated == -1) &&
            MembershipForm}
          </div>
          <div className="actions">
            <button className="btn button action" type="submit"
                    disabled={isPlanLite || disableSubmit}>{__('Save changes')}
            </button>
          </div>
        </form>

      </div>
    );
    return this.state.loading ? this.renderLoading() : form;
  }

  componentWillMount () {
    this.showLoading();
    const { RolesAccess } = this.props;
    let label = '';
    switch (RolesAccess.userRolesAccess.type) {
      case 'admin-user':
        label = __('Admin users');
        break;
      case 'memberships':
        label = pda_gold_v3_data.pda_membership_integration_activated == -1
          ? __('Choose custom memberships')
          : __('Use default setting');
        break;
      case 'author':
        label = __('The file\'s author');
        break;
      case 'logger-in-user':
        label = __('Logged-in users');
        break;
      case 'blank':
        label = __('No user roles');
        break;
      case 'anyone':
        label = __('Anyone');
        break;
      case 'custom-roles':
        label = __('Choose custom roles');
        break;
      case 'default':
        label = __('Use default setting');
        break;
      case '':
        label = __('Use default setting');
        break;
    }
    let roles = '';
    const value = RolesAccess.userRolesAccess.roles !== ''
      ? RolesAccess.userRolesAccess.roles.split(';')
      : '';
    if (value) {
      roles = value.map((v) => {
        return {
          value: v,
          label: v,
        };
      });
    }
    this.setState(prevState => ({
      ...prevState,
      value: roles,
      selectedOption: {
        value: RolesAccess.userRolesAccess.type !== ''
          ? RolesAccess.userRolesAccess.type
          : 'default',
        label: label,
      },
      loading: false,
    }));
  }

  handleSelectChange = (value) => {
    this.setState(
      prevState => (
        {
          ...prevState, value,
        }
      ));
  };

  handleChange = (selectedOption) => {
    this.setState(prevState => ({
      ...prevState,
      selectedOption,
    }));
  };

  renderLoading () {
    return (
      <div className="loading">{__('Loading Data...')}</div>
    );
  }

  setValueForMemberships (valueMember) {
    let result = '';
    if (this.state[valueMember] !== '') {
      console.log('Value member', this.state[valueMember]);
      const memberships = this.state[valueMember].map((mem) => {
        return mem.value;
      });
      result = memberships.join(';');
    }
    return result;
  }

  onSubmit = (values) => {
	this.setState({
	  disableSubmit: true,
	});

    values.user_roles = this.setValueForMemberships('value');
    values.file_access_permision = this.state.selectedOption.value;
    if (values.file_access_permision !== 'custom-roles') {
      values.user_roles = '';
    }

    if (this._membershipComp) {
      const { memOpts, isValidated } = this._membershipComp.getSelectedMembershipOptions();
      values = { ...values, ...memOpts };

      if (values.memberships_fap === 'custom-memberships') {
        if (!isValidated) {
          toastr.error(MESSAGES.ERR_MEMBERSHIPS_NON);
	      this.setState({
		    disableSubmit: false,
	      });
          return;
        }
      }
    }

    const { addUserRoles, postId, handleChangeTab } = this.props;
    addUserRoles(postId, values).then(() => {
      const { membersSelect } = this.props;
      this.setState({
        membersSelect,
      });
      toastr.success(MESSAGES.UPDATE_PERMISSION_OK);
      changeTab(TABS.TABLE);
      handleChangeTab(TABS.TABLE);
    }).
    catch(error => {
	    console.log('Error happened due to:', error);
	    toastr.error(error.message);
    }).
    finally(() => {
	    this.setState({
		    disableSubmit: false,
	    });
    });
  };
}

const Form = reduxForm({
  form: 'UserAccessForm',
})(UserAccessForm);

const mapStateToProps = state => {
  return {
    UserRoles: state.allUserRoles,
    iPBlockData: state.iPBlockData,
    RolesAccess: state.userRolesAccess,
    membersSelect: state.membersSelect,
    plan: state.getPlan,
  };
};

const mapActionsToProps = (dispatch) => {
  return bindActionCreators({ getAllUserRoles, addUserRoles, getPlan },
    dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(Form);
